import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  ButtonGroup,
  Modal,
} from 'anf-core-react';

import TmntText from '../tmnt-text/tmnt-text';

export default function CancelModal({
  isOpen,
  setOpen,
  handleSubmit,
}) {
  const onSubmit = useCallback((e) => {
    window.dispatchEvent(new CustomEvent('dre:clearstorage'));
    handleSubmit(e);
  }, [handleSubmit]);

  return (
    <Modal
      id="exchange-view-cancel-modal"
      isOpen={isOpen}
      heading={
        <h3><TmntText k="DRE_CANCEL" /></h3>
        }
      onClose={() => setOpen(false)}
    >
      <p className="exchange-view-cancel-modal-text">
        <TmntText k="DRE_AREYOUSURE" />
      </p>
      <ButtonGroup variant="vertical-spaced">
        <Button variant="secondary" onClick={onSubmit}>
          <TmntText k="DRE_YESCANCEL" />
        </Button>
        <Button variant="borderless" onClick={() => setOpen(false)}>
          <TmntText k="DRE_KEEP" />
        </Button>
      </ButtonGroup>
    </Modal>
  );
}

CancelModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func,
};
